export default "__VITE_PUBLIC_ASSET__8e701f0d__"